export const notificationType = [
  {
    value: 'Inicio',
    label: 'common.dataSelect.notificationType.init',
  },
  {
    value: 'Fin-OK',
    label: 'common.dataSelect.notificationType.endSuccess',
  },
  {
    value: 'Fin-Error',
    label: 'common.dataSelect.notificationType.endError',
  },
  /*{
    value: 'Autorizacion',
    label: 'common.dataSelect.notificationType.autorize',
  },*/
];

export const pollingType = [
  { value: 'text', label: 'common.dataSelect.pollingType.text' },
  { value: 'number', label: 'common.dataSelect.pollingType.number' },
  { value: 'option', label: 'common.dataSelect.pollingType.option' },
];

export const pollingOptions = [
  { value: 'op1', name: 'common.dataSelect.pollingOption.optionOne' },
  { value: 'op2', name: 'common.dataSelect.pollingOption.optionTwo' },
];

export const levelDetail = [
  { value: '0', label: 'common.dataSelect.levelDetail.normal' },
  { value: '1', label: 'common.dataSelect.levelDetail.verbose' },
  { value: '2', label: 'common.dataSelect.levelDetail.moreVerbose' },
  { value: '3', label: 'common.dataSelect.levelDetail.debug' },
  { value: '4', label: 'common.dataSelect.levelDetail.connectionDebug' },
  { value: '5', label: 'common.dataSelect.levelDetail.connectionDebugplus' },
];

export const jobType = [
  { value: 'EJ', label: 'common.dataSelect.jobType.eject' },
  { value: 'CO', label: 'common.dataSelect.jobType.check' },
  { value: 'ES', label: 'common.dataSelect.jobType.scan' },
];

export const scmType = [
  { value: 'Manual', label: 'Manual' },
  { value: 'Git', label: 'Git' }
]
